<template>
    <div>
        <div style="background: #222222">
            <img src="../../assets/mk体育(中国)官方网站 - mk sports/about/8.png" style="width: 100%;height: auto;display: block" alt="">
        </div>
        <div class="padding-20  background-white ">
            <div class="index-div-content index-div-content-2">
                <div class="flex">
                    <div><img width="10" src="/assets/mk体育(中国)官方网站 - mk sports/about/1.png" alt=""></div>
                    <div class="padding-left-20">
                        <div><h3> 合作咨询</h3></div>
                        <div><p> Cooperative consultation</p></div>
                    </div>
                </div>
                <div class="div-panel margin-top-30">
                    <div class="div-panel-header">联系方式</div>
                    <div class="flex div-panel-content margin-top-30 ">
                        <div>
                            <img width="108" src="../../assets/img/weixin1.png" alt="">
                        </div>
                        <div class="padding-left-20">
                            <div><h3 class="name"> 林先生</h3></div>
                            <div><p> 电话：186 1006 7499</p></div>
                            <div><p> 邮箱：he.lin@mk体育(中国)官方网站 - mk sports.tech</p></div>

                        </div>
                    </div>
                </div>
                <div class="div-panel margin-top-30">
                    <div class="div-panel-header">咨询信息</div>
                    <div class=" div-panel-content margin-top-30 ">
                        <el-form :model="commitInfo" label-position="top" :rules="rules" ref="ruleForm"
                                 class="demo-form-inline">
                            <el-row :gutter="30">
                                <el-col :span="12">
                                    <el-form-item label="联系人名称" prop="username">
                                        <el-input v-model="commitInfo.username" ></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="联系人手机" prop="phone">
                                        <el-input v-model="commitInfo.phone" ></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col>
                                    <el-form-item label="合作意向和需求说明" prop="infoContent">
                                        <el-input
                                                type="textarea"
                                                :rows="4"
                                                v-model="commitInfo.infoContent">
                                        </el-input>
                                    </el-form-item>

                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col>
                                    <el-form-item style="text-align: center">
                                        <el-button type="primary" @click="onSubmit" style="width: 100px">提交</el-button>
                                    </el-form-item>
                                </el-col>
                            </el-row>


                        </el-form>
                    </div>
                </div>


            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Consultation",
        data() {
            let validatePhone = (rule, value, callback) => {
                console.log(value)
                if (value === '') {
                    callback(new Error('请输入手机号'));
                } else if (!(/^1[3456789]\d{9}$/.test(value))) {
                    callback(new Error('请输入正确的手机号'))
                } else {
                    callback();
                }
            };
            return {
                commitInfo: {},
                rules: {
                    username: [
                        {required: true, message: '请输入用户名', trigger: 'blur'},
                    ],
                    phone: [{required: true,validator: validatePhone, trigger: "blur"}],
                },
            }

        },
        methods: {
            onSubmit() {
                this.$refs['ruleForm'].validate((valid) => {
                    console.log(valid)
                    if (valid) {
                         this.$message.success("信息已经提交成功，我们将会尽快联系你。")
                    } else {
                        return false;
                    }
                });
            }
        }
    }
</script>

<style scoped lang="scss">


    .name {
        color: #1B1B1B;
    }

    #hash1 {
        .index-el-col-1 {
            .img:hover {
                img {
                    transform: scale(1.1);
                }
            }

            .img {
                img {
                    transition: all 0.6s;
                }
            }
        }
    }

    .company-img {
        margin-top: 40px;

        .img-info:hover {
            img {
                transform: scale(1.1);
            }
        }

        .img-info {
            overflow: hidden;

            img {
                transition: all 0.6s;
            }
        }


    }

    h3 {
        font-size: 28px;
        color: #005DAB;
        margin-bottom: 10px;
    }

    .company-content {
        p {
            margin-bottom: 30px;
            line-height: 32px;
        }

        ul {
            margin-bottom: 30px;
            list-style: none;

            li {
                line-height: 32px;
                margin-bottom: 5px;
            }
        }
    }

    .index-inyong {
        background: url(/assets/mk体育(中国)官方网站 - mk sports/about/1.png) 100% 100% no-repeat;
        background-size: cover;
        height: 400px;
    }

    #swiperBox1 {
        position: relative;
        width: 100%;
        overflow: hidden;

        .swiper-button-prev, .swiper-button-next {
            bottom: 0px;
            top: auto;
            width: 32px;
            height: 32px;
            background: #005DAB;
            line-height: 32px;
            text-align: center;
            color: white;
        }

        .swiper-button-prev {
            left: calc(50% - 32px);
        }

        .swiper-button-next {
            left: calc(50% + 1px);
        }
    }

    .flex {
        display: flex;
        justify-items: center;
    }
</style>